import gql from 'graphql-tag';

export default gql`
    query getInventoryExtract($jobId: Int, $key: String) {
        getInventoryExtract(jobId: $jobId, key: $key) {
            boxDetails {
                boxId
                boxDesc
                padLocation
                doNotUse
                weight
                weightDelivered
                weightRemaining
                proppantDesc
                stageSheetId
                associatedtoStage
                stageDetails
                sandTicket
                sandPO
                loadId
                boxStatus
                driverName
                truckNumber
                chassisNumber
                companyName
                grossWeight
                tareWeight
                lofa
            }
        }
    }
`;
